import { useMemo } from "react"
import { flatten, inRange, times } from "lodash"

import { LUXURY_TYPE } from "extensions/iconsiam/constants"
import { usePost } from "hooks/post/usePost"

const SLIDE_LOOP_COUNT = 5
const SLIDE_AUTO_COUNT = 3

export const useLuxury = () => {
  const { hasData, postData: luxuries } = usePost(LUXURY_TYPE)

  const luxurySlides = useMemo(() => {
    if (!hasData) return []
    const totalSlides = luxuries.length
    // Ensure slides (3–${SLIDE_LOOP_COUNT}) are duplicated for Swiper loop functionality
    return inRange(totalSlides, 3, SLIDE_LOOP_COUNT)
      ? flatten(times(3, () => luxuries))
      : luxuries
  }, [hasData, luxuries])

  const loop = luxurySlides.length > SLIDE_LOOP_COUNT

  const autoPlay = luxurySlides.length > SLIDE_AUTO_COUNT

  return {
    hasData,
    luxuries,
    luxurySlides,
    loop,
    autoPlay,
  }
}
